export const useSearch = () => useState('is-search-open', () => false)